import { render, staticRenderFns } from "./ReportDealerSales.vue?vue&type=template&id=145d3723&scoped=true&"
import script from "./ReportDealerSales.vue?vue&type=script&lang=js&"
export * from "./ReportDealerSales.vue?vue&type=script&lang=js&"
import style0 from "./ReportDealerSales.vue?vue&type=style&index=0&id=145d3723&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145d3723",
  null
  
)

export default component.exports